import React from 'react';

/** Zeile „Bezeichnung … Wert“ in Karten der Einheit-Bereiche (Screen 36: Kontakt). */
export function DatenZeile({ label, wert, zahl = false }: { label: string; wert: React.ReactNode; zahl?: boolean }) {
  return (
    <div className="flex items-center justify-between" style={{ gap: 12, padding: '11px 0', borderBottom: '1px solid var(--line)' }}>
      <span style={{ fontSize: 14, color: 'var(--ink2)' }}>{label}</span>
      <span className={`text-right min-w-0 ${zahl ? 'immo-zahl' : ''}`} style={{ fontSize: 14, fontWeight: 700, overflowWrap: 'anywhere' }}>{wert || '–'}</span>
    </div>
  );
}

/** Zwei Karten nebeneinander, unter 640 px untereinander. */
export function KartenRaster({ children, minBreite = 280 }: { children: React.ReactNode; minBreite?: number }) {
  return <div className="grid" style={{ gridTemplateColumns: `repeat(auto-fit,minmax(min(${minBreite}px,100%),1fr))`, gap: 14 }}>{children}</div>;
}

/** IBAN in Vierergruppen. */
export function ibanText(iban: string | null | undefined): string {
  return (iban ?? '').replace(/\s/g, '').toUpperCase().replace(/(.{4})/g, '$1 ').trim();
}
